import type { NewsItem } from '@/types/media';

export const newsList: NewsItem[] = [
  {
    id: 'n1',
    title: '《星辰大海》收官在即，科幻剧迎来创作新高峰',
    summary: '随着《星辰大海》剧情进入高潮，国产科幻剧的制作水准与叙事野心再次成为行业热议的话题。',
    content: '近期热播的《星辰大海》凭借扎实的世界观设定与细腻的人物塑造，成为本季最受关注的科幻剧集。剧组在特效与实景拍摄上的投入，让星际移民这一宏大命题有了更具质感的呈现。业内分析认为，该剧的成功标志着国产科幻剧正从概念尝试走向成熟表达，为后续作品提供了可借鉴的路径。',
    source: '樱花影视观察',
    date: '2025-10-11',
  },
  {
    id: 'n2',
    title: '秋季档电影市场回暖，多部现实题材新片定档',
    summary: '十月以来多部现实题材影片陆续定档，市场观影热情回升，票房表现值得期待。',
    content: '进入十月，电影市场逐渐走出淡季。多部聚焦普通人生活的现实题材影片宣布定档，题材涵盖家庭、职场与成长。发行方表示，观众对贴近生活的故事接受度越来越高，这将推动创作者更加重视内容本身的质量与温度。',
    source: '影视产业日报',
    date: '2025-10-09',
  },
  {
    id: 'n3',
    title: '《长安十二时》口碑持续发酵，古装悬疑再受关注',
    summary: '凭借精良的美术与缜密的叙事，《长安十二时》在观众中收获高分评价，古装悬疑题材热度回温。',
    content: '《长安十二时》自上线以来讨论度居高不下。有观众评价，该片在有限的时间内完成了多条线索的收束，节奏把控出色。业内认为，古装悬疑这一类型正迎来新的创作窗口，如何在历史质感与类型叙事之间取得平衡，是创作者需要持续探索的课题。',
    source: '樱花影视观察',
    date: '2025-10-06',
  },
  {
    id: 'n4',
    title: '剧集“短而精”趋势明显，微短剧进入品质竞争阶段',
    summary: '越来越多制作方开始尝试十几集的精品短剧，微短剧行业正从数量扩张转向品质竞争。',
    content: '近一年来，单集时长更短、总集数更精简的剧集明显增多。多位制片人表示，观众的注意力更加碎片化，但对内容质量的要求并未降低。如何在更短的篇幅里讲好一个完整的故事，成为编剧与导演共同面对的挑战。',
    source: '内容前线',
    date: '2025-10-03',
  },
  {
    id: 'n5',
    title: '经典老片修复重映，情怀与品质双重加持',
    summary: '多部经典老片完成高清修复后重新登陆院线与流媒体，唤起观众的集体记忆。',
    content: '一批承载着时代记忆的经典影片经过数字修复后重回观众视野。修复团队介绍，除画面外，声音也进行了重新处理，力求还原当年的观影体验。不少年轻观众借此第一次走进这些作品，形成了跨越代际的对话。',
    source: '光影档案',
    date: '2025-09-29',
  },
  {
    id: 'n6',
    title: '悬疑探案题材持续走热，法医视角成新亮点',
    summary: '以法医、刑侦为切入点的剧集数量增多，专业视角为类型创作带来新鲜感。',
    content: '近期多部悬疑探案剧选择从法医或专业鉴定人员的视角切入，通过严谨的细节还原案件侦破过程。观众反馈，这类作品既有推理的乐趣，也兼具一定科普价值。创作者表示，专业性是把双刃剑，需要在准确与趣味之间拿捏分寸。',
    source: '类型剧研究社',
    date: '2025-09-26',
  },
  {
    id: 'n7',
    title: '国风美学走向海外，多部古装剧登陆国际平台',
    summary: '搭载东方美学与传统文化元素的古装剧，正受到越来越多海外观众的关注。',
    content: '随着多部古装剧在海外平台上线，服装、道具与场景中蕴含的东方美学引发讨论。有海外观众留言称，剧中的节气、建筑与礼仪让他们对中国文化产生兴趣。业内人士认为，文化表达与普世情感的融合，是国剧出海的关键。',
    source: '文化出海观察',
    date: '2025-09-22',
  },
  {
    id: 'n8',
    title: '治愈系作品受青睐，都市人寻找“情绪出口”',
    summary: '温暖治愈的单元剧与美食、生活题材作品，成为不少观众舒缓压力的选择。',
    content: '在快节奏的都市生活中，主打温暖与治愈的影视作品收获稳定受众。以深夜食堂为代表的单元叙事，通过一个个小故事抚慰人心。观众表示，这类作品不追求强烈的戏剧冲突，却能在细节中带来被理解的感觉。',
    source: '樱花影视观察',
    date: '2025-09-18',
  },
];